import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import React from 'react';
import GuideLayout from '../GuideLayout';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const statusChart = `stateDiagram-v2
    [*] --> 草稿 : 新建需求单
    草稿 --> 待审批 : 发布
    草稿 --> [*] : 删除
    待审批 --> 已批准 : 审批通过
    待审批 --> 已驳回 : 审批驳回
    已驳回 --> 待审批 : 修改后重新发布
    已批准 --> 已完成 : 系统派生计划\n采购/生产任务已生成`;
const statusColumns = [{
  title: '状态',
  dataIndex: 'status'
}, {
  title: '含义',
  dataIndex: 'meaning'
}, {
  title: '你能做什么',
  dataIndex: 'action'
}];
const statusData = [{
  status: '草稿',
  meaning: '刚创建',
  action: '编辑物料明细、删除、发布'
}, {
  status: '待审批',
  meaning: '已提交等待审批',
  action: '等待（可撤销回草稿）'
}, {
  status: '已驳回',
  meaning: '审批退回',
  action: '修改后重新发布'
}, {
  status: '已批准',
  meaning: '审批通过，MRP 自动运算',
  action: '等待系统生成采购/生产任务'
}, {
  status: '已完成',
  meaning: '计划已派生，任务已下发',
  action: '只读查看'
}];
const afterApprovalChart = `graph LR
    A["你提交需求单"] --> B["主管审批"]
    B --> C["系统自动算料"]
    C --> D{"该物料\\n怎么获取?"}
    D -->|"外购"| E["生成采购任务\\n→ 采购去处理"]
    D -->|"自制"| F["生成生产工单\\n→ 生产去处理"]
    E --> G["你可以随时\\n查看进度"]
    F --> G`;
const sections = [{
  id: 'what-is',
  label: '什么是需求单？'
}, {
  id: 'tips',
  label: '操作要点'
}, {
  id: 'status-flow',
  label: '需求单状态流转'
}, {
  id: 'after-approval',
  label: '提了需求之后会怎样？'
}];
export default function Demand() {
  return /*#__PURE__*/React.createElement(GuideLayout, {
    title: "\u9700\u6C42\u63D0\u62A5\u2014\u2014\u8BA9\u7CFB\u7EDF\u77E5\u9053\u4F60\u8981\u4EC0\u4E48",
    firstQuestion: "\u6211\u9700\u8981\u4E00\u4E9B\u7269\u6599\uFF0C\u8BE5\u600E\u4E48\u544A\u8BC9\u7CFB\u7EDF\uFF1F\u63D0\u4E86\u4E4B\u540E\u4F1A\u600E\u6837\uFF1F",
    sections: sections
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "what-is"
  }, /*#__PURE__*/React.createElement("h2", null, "\u4EC0\u4E48\u662F\u9700\u6C42\u5355\uFF1F"), /*#__PURE__*/React.createElement("blockquote", null, "\u5F53\u4F60\u9700\u8981\u67D0\u4E9B\u7269\u6599\uFF08\u5907\u8D27\u3001\u7814\u53D1\u6D4B\u8BD5\u3001\u9879\u76EE\u7528\u6599\u7B49\uFF09\uFF0C\u4F46\u4E0D\u662F\u901A\u8FC7\u9500\u552E\u8BA2\u5355\u89E6\u53D1\u7684\uFF0C\u5C31\u901A\u8FC7\u300C\u9700\u6C42\u5355\u300D\u544A\u8BC9\u7CFB\u7EDF\u3002\u9700\u6C42\u5355\u6279\u51C6\u540E\uFF0C\u7CFB\u7EDF\u4F1A\u81EA\u52A8\u7B97\u6599\u3001\u751F\u6210\u91C7\u8D2D\u6216\u751F\u4EA7\u4EFB\u52A1\u3002"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "\u9002\u7528\u573A\u666F\uFF1A"), "\u5907\u8D27\u91C7\u8D2D\u3001\u7814\u53D1\u7528\u6599\u3001\u9879\u76EE\u4E13\u7528\u6599\u3001\u4E34\u65F6\u8865\u5145\u9700\u6C42")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "tips"
  }, /*#__PURE__*/React.createElement("h2", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-tips']
  }, /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u9009\u5BF9\u5730\u5740"), "\u2014\u2014\u9700\u6C42\u5355\u8981\u6307\u5B9A\u6536\u8D27\u5730\u5740\uFF0C\u8FD9\u5F71\u54CD\u540E\u7EED\u7684\u91C7\u8D2D\u6536\u8D27\u5730\u70B9"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u5199\u6E05\u7528\u9014"), "\u2014\u2014\u7528\u9014\u5B57\u6BB5\u5E2E\u52A9\u5BA1\u6279\u4EBA\u5224\u65AD\u9700\u6C42\u7684\u5408\u7406\u6027"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u6279\u51C6\u540E\u4E0D\u7528\u50AC"), "\u2014\u2014\u7CFB\u7EDF\u81EA\u52A8\u7B97\u6599\u5E76\u6D3E\u751F\u4EFB\u52A1\uFF0C\u4F60\u53EF\u4EE5\u968F\u65F6\u5728\u9700\u6C42\u5355\u8BE6\u60C5\u91CC\u770B\u5230\u8FDB\u5C55"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u53D8\u66F4\u8D70\u53D8\u66F4\u5355"), "\u2014\u2014\u5DF2\u6279\u51C6\u7684\u9700\u6C42\u5355\u4E0D\u80FD\u76F4\u63A5\u6539\uFF0C\u8981\u8D70\u53D8\u66F4\u6D41\u7A0B")))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "status-flow"
  }, /*#__PURE__*/React.createElement("h2", null, "\u9700\u6C42\u5355\u72B6\u6001\u6D41\u8F6C"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: statusChart
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: statusColumns,
    data: statusData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "after-approval"
  }, /*#__PURE__*/React.createElement("h2", null, "\u63D0\u4E86\u9700\u6C42\u4E4B\u540E\u4F1A\u600E\u6837\uFF1F"), /*#__PURE__*/React.createElement("blockquote", null, "\u8FD9\u662F\u63D0\u9700\u6C42\u7684\u4EBA\u6700\u5173\u5FC3\u7684\u95EE\u9898\u3002"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: afterApprovalChart
  })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "\u4F60\u80FD\u770B\u5230\u7684\u8FDB\u5EA6\uFF1A"), "\u9700\u6C42\u5355\u8BE6\u60C5\u4E2D\u53EF\u4EE5\u770B\u5230\u6BCF\u4E00\u884C\u7269\u6599\u5BF9\u5E94\u7684\u91C7\u8D2D\u4EFB\u52A1\u6216\u751F\u4EA7\u5DE5\u5355\u72B6\u6001\u3002")));
}